module.exports = __webpack_public_path__ + "img/panoptic_ai_vitals.b5bc539c.png";